@let secondaryNavigation = navigationSecondary();
@let useLeftbar =
  !!inputLeftBar() && !showAuthOrganizationSelectionModal() && !showAuthLicenseCapacityModal();

<evc-navigations
  class="topbar"
  [isIms]="isIms()"
  [displayThemeSelector]="!inputForcedTheme()"
  [displayUserMenu]="displayUserMenu()"
  [inputForcedLayout]="inputForcedLayout()"
  [navigationSecondary]="secondaryNavigation"
  [useLeftbar]="useLeftbar"
  [login]="login()"
  [logout]="logout()"
  [changeOrganization]="changeOrganization()">
  <ng-content
    custom-logo
    select="[custom-logo]" />
  <ng-content
    extra-settings
    select="[top-bar-extra-settings]" />
  <ng-content
    burger-top-content
    select="[burger-top-content]" />
  <ng-content
    burger-bottom-content
    select="[burger-bottom-content]" />
  <ng-content
    leftbar-top-content
    select="[leftbar-top-content]" />
  <ng-content
    leftbar-bottom-content
    select="[leftbar-bottom-content]" />
  <ng-content
    mobile-main-action
    select="[mobile-main-action]" />
</evc-navigations>

@if (useLeftbar) {
  <!-- fake leftbar just to manage main layout
   actual menu is in evc-navigations (position fixed) -->
  <evc-fake-leftbar class="leftbar" />
}

<!-- MAIN APPLICATION FRAME -->
@if (showAuthOrganizationSelectionModal()) {
  <evc-auth-organization-selection-modal
    (orgSelected)="onOrgSelected($event)"
    (useAnotherAccount)="onUseAnotherAccount()" />
} @else if (showAuthLicenseCapacityModal()) {
  <evc-auth-license-capacity-modal (orgSelected)="onOrgSelected($event)" />
}
<ng-content />

<!-- LAYERS ABOVE APPLICATION -->
<div class="layers">
  <evc-loader class="loader" />

  <div class="layers__toasts">
    @if (toastService.queue().length > 0) {
      <evc-toast class="toast" />
    }
  </div>

  <div class="layers__modal">
    <ng-template #modalContainer></ng-template>
  </div>

  <ng-content select="[layers]" />
</div>
